import React, { useState } from "react"
import { CSSTransition, TransitionGroup } from "react-transition-group"
import styled from "styled-components"
import { useInterval } from "../../../helpers"
import { AppFunctionComponent } from "../../../types"

const ToggleableText = styled.span<{ visible: boolean }>`
  position: absolute;
  white-space: nowrap;
  left: 0;
  top: 0;
  display: inline;
  opacity: 0;
  ${(props) => props.visible && "opacity: 1;"};
`

const transitionName = "example"

const TransitionText = styled(CSSTransition)`
  transition: all 0.3s ease-out;
  &.${transitionName}-enter {
    transform: translateY(${0.8 * 1.5}em);
  }

  &.${transitionName}-enter.${transitionName}-enter-active {
    transition: all 0.3s ease-out;
  }

  &.${transitionName}-exit {
    transition: all 0.3s ease-out;
  }

  &.${transitionName}-exit.${transitionName}-exit-active {
    transform: translateY(-${0.8 * 1.5}em);
  }
`

const TransitionWrapper = styled(TransitionGroup)`
  position: absolute;
  overflow: hidden;
  height: 1.5em;
  width: 100%;
  white-space: nowrap;
  display: inline-block;
`

interface Props {
  texts: string[]
  delay: number
}

const AnimatedTexts: AppFunctionComponent<Props> = ({ texts, delay }) => {
  const [index, setIndex] = useState(0)

  useInterval(() => {
    setIndex(index + 1)
  }, delay)

  return (
    <TransitionWrapper>
      {texts.map(
        (text, textIndex) =>
          index % texts.length === textIndex && (
            <TransitionText
              classNames={transitionName}
              enter
              leave
              timeout={{ enter: 300, exit: 300 }}
              key={text}
            >
              <ToggleableText
                visible={index % texts.length === textIndex}
                dangerouslySetInnerHTML={{
                  __html: text,
                }} /* TODO: consider another way to pass text */
              />
            </TransitionText>
          )
      )}
    </TransitionWrapper>
  )
}

export default AnimatedTexts
